import { GATES_API_URL, GATES_FILTER_URL } from 'constants/ApiConstants';
import * as types from 'modules/gates/actionTypes';

/**
 * @param {import('../types/actions').GetGatesPayload} params
 * @param {Object} meta
 * @returns {import('../types/actions').GetGatesAction}
 */
export const fetchGates = (params, meta = {}) => ({
  type: types.FETCH_GATES,
  payload: {
    request: {
      method: 'GET',
      url: GATES_FILTER_URL,
      params,
    },
  },
  meta: {
    '@app-request': true,
    ...meta
  }
});

/**
 * @param {string} gateId
 * @param {Object} params
 * @param {Object} meta
 * @returns {import('../types/actions').GetGateAction}
 */
export const fetchGate = (gateId, params, meta = {}) => ({
  type: types.FETCH_GATE,
  payload: {
    request: {
      method: 'GET',
      url: `${GATES_API_URL}/${gateId}`,
      ...params
    }
  },
  meta: {
    '@app-request': true,
    ...meta
  }
});

/**
 * @param {Partial<import('../types/gate-data').Gate>} gate
 * @param {Object} meta
 * @returns {import('../types/actions').CreateGateAction}
 */
export const createGate = (gate, meta = {}) => ({
  type: types.CREATE_GATE,
  payload: {
    request: {
      method: 'POST',
      url: GATES_API_URL,
      data: gate
    }
  },
  meta
});

/**
 * @param {Partial<import('../types/gate-data').Gate>} gate
 * @param {Object} meta
 * @returns {import('../types/actions').UpdateGateAction}
 */
export const updateGate = (gate, meta = {}) => ({
  type: types.UPDATE_GATE,
  payload: {
    request: {
      method: 'PUT',
      url: `${GATES_API_URL}/${gate.id}`,
      data: gate
    }
  },
  meta
});

/**
 * @param {string} gateId
 * @param {Object} meta
 * @returns {import('../types/actions').DeleteGateAction}
 */
export const deleteGate = (gateId, meta = {}) => ({
  type: types.DELETE_GATE,
  payload: {
    gateId,
    request: {
      method: 'DELETE',
      url: `${GATES_API_URL}/${gateId}`
    }
  },
  meta
});

/**
 * @param {string} gateId
 * @param {Object} meta
 * @returns {import('../types/actions').DeleteGateSuccessAction}
 */
export const deleteGateSuccess = (gateId, meta = {}) => ({
  type: types.DELETE_GATE_SUCCESS,
  payload: gateId,
  meta
});

/**
 * @param {import('../types/actions').GetGatesPayload} params
 * @param {Object} meta
 * @returns {import('../types/actions').FetchGateSelectAction}
 */
export const fetchAvailableGates = (params, meta = {}) => ({
  type: types.FETCH_AVAILABLE_GATES,
  payload: {
    request: {
      method: 'GET',
      url: GATES_FILTER_URL,
      params,
    },
  },
  meta: {
    '@app-request': true,
    ...meta
  }
});

/**
 * @param {import('../types/actions').GetGatesPayload} params
 * @param {Object} meta
 * @returns {import('../types/actions').FetchGateSelectAction}
 */
export const fetchGatesFilter = (params, meta = {}) => ({
  type: types.FETCH_GATES_FILTER,
  payload: {
    request: {
      method: 'GET',
      url: GATES_FILTER_URL,
      params,
    },
  },
  meta: {
    '@app-request': true,
    ...meta
  }
});

/**
 * @param {string} field
 * @param {any} value
 * @param {Object} meta
 * @returns {import('../types/actions').SetGatesDashboardFilterAction}
 */
export const setGatesDashboardFilter = (field, value, meta = {}) => ({
  type: types.SET_GATES_DASHBOARD_FILTER,
  payload: { field, value },
  meta
});

/**
 * @param {Object} meta
 * @returns {import('../types/actions').ClearGatesDashboardFilterAction}
 */
export const clearGatesDashboardFilter = (meta = {}) => ({
  type: types.CLEAR_GATES_DASHBOARD_FILTER,
  meta
});

/**
 * @param {string} gateId
 * @param {Object} meta
 * @returns {import('../types/actions').RestrictedAccessRelayCheckAction}
 */
export const restrictedAccessRelayCheck = (gateId, meta = {}) => ({
  type: types.RESTRICTED_ACCESS_RELAY_CHECK,
  payload: {
    request: {
      method: 'GET',
      url: `${GATES_API_URL}/${gateId}/relay/check`
    }
  },
  meta
});
